import { Component, OnInit, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { ActivatedRoute } from '@angular/router';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

import { Subscription } from 'rxjs';
import { DistanciaEntreMovilesService } from 'src/app/services/flota/distancia-entre-moviles-service/distancia-entre-moviles.service';

import { MapaPopUpComponent } from 'src/app/shared/mapa/mapa-popup/mapa-popup.component';

@Component({
  selector: 'app-distancia-entre-moviles',
  templateUrl: './distancia-entre-moviles.component.html',
  styleUrls: ['./distancia-entre-moviles.component.scss']
})
export class DistanciaEntreMovilesComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort; 
  pageEvent: PageEvent;

  public contClass: string = 'container-fluid maincont';
  public filter: any = {
    desde : null,
    hasta : null,
    velocidad: 10,
    buscar: '',
    orderby: 'cod_vehiculo',
    sortby: 'asc',
    pageIndex: 0,
    pageSize: 10
  };
  public loading: boolean = false;  
  public loadingPdf: boolean = false;  
  public loadingXls: boolean = false;  

  public dataSource: MatTableDataSource<any>;
  public distanciaTotal : any = 0;
  public odometroTotal : any = 0;
  public consumoTotal : any = 0;
  public tableCount;
  public tableDisplay: Boolean = true;
  public showLoading: Boolean = false;

  filtroForm : Subscription;

  displayedColumns: string[] = [
    'cod_equipo_rastreo',
    'des_equipo_ratreo',
    'distancia',
    'consumo',    
    'odometro_total',
    'distancia_entre',
    'ver_mapa',
  ];

  constructor(
    private gtp : Gtp,
    private route: ActivatedRoute,
    private apiCall: DistanciaEntreMovilesService,
    private cdRef:ChangeDetectorRef,
    public dialog: MatDialog
  ) { 
    this.filtroForm = this.apiCall.getFiltroForm().subscribe(msg => {      
      this.filter.desde = msg.desde;
      this.filter.hasta = msg.hasta;
      this.loadInforme();
    });
  }

  ngOnInit() {
    
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    if(this.dataSource.data.length==0){
      this.tableDisplay = false;
    }

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.filtroForm.unsubscribe();
  }

  loadInforme(){
    this.loading = true;
    this.apiCall.getDistanciaEntreMoviles(this.filter).subscribe(res => {
      this.dataSource = new MatTableDataSource(res['data']);
      this.tableCount = res['recordsTotal'];
      this.dataSource.sort = this.sort;
      this.loading = false;
      this.tableDisplay = true;
      this.getTotalValores();
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    this.loadInforme();
  }

  setPagination(event?) { 
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    this.loadInforme();
    return event;
  }

  getPageSizeOptions(): number[] {    
    return [10, 20, this.tableCount];
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);    
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  getTotalValores() {
    this.consumoTotal = this.dataSource.data.map(t => t.consumo).reduce((acc, value) => acc + parseFloat(value), 0);
    this.distanciaTotal = this.dataSource.data.map(t => t.distancia).reduce((acc, value) => acc + parseFloat(value), 0);
    this.odometroTotal = this.dataSource.data.map(t => t.odo_inicial).reduce((acc, value) => acc + parseFloat(value), 0);
    this.odometroTotal = parseFloat(this.odometroTotal.toString()).toFixed(2);
  }

  verMapa(latitud, longitud, rotacion){
    this.dialog.open(MapaPopUpComponent, {
      data: {
        latitud: latitud, 
        longitud: longitud,
        rotacion: parseFloat(rotacion)
      }
    });
  }

  exportPDF(){
    this.loadingPdf = true;            
    var colores = this.gtp.tableColors;
    var data = [
      //Agregar Header
      [
        { text: 'Cod Equipo', fillColor: colores.header, fontSize: 14 },
        { text: 'Descripción', fillColor: colores.header, fontSize: 14 },
        { text: 'Consumo', fillColor: colores.header, fontSize: 14 },
        { text: 'Distancia', fillColor: colores.header, fontSize: 14 },
        { text: 'Odometro Total', fillColor: colores.header, fontSize: 14 },
      ]
    ];
    //Carga Registros
    this.dataSource.data.forEach((e,i) => {
      var bgcolor = (i%2==0) ? colores.tdinterval : colores.td;
      data.push([
        { text: e.cod_equipo_rastreo, fillColor: bgcolor, fontSize: 11 },
        { text: e.des_equipo_ratreo, fillColor: bgcolor, fontSize: 11 },
        { text: (e.consumo != 0) ? e.consumo+' Litros' : 'Falta Personalizar', fillColor: bgcolor, fontSize: 11 },
        { text: parseFloat(e.distancia).toFixed(2)+' Km.', fillColor: bgcolor, fontSize: 11 },
        { text: parseFloat(e.odo_inicial).toFixed(2)+' Km.', fillColor: bgcolor, fontSize: 11 },
      ]);
    });
    //Totales    
    data.push([
      { text: '', fillColor: colores.footer, fontSize: 14 },
      { text: '', fillColor: colores.footer, fontSize: 14 },
      { text: this.consumoTotal+' Litros.', fillColor: colores.footer, fontSize: 14 },
      { text: parseFloat(this.distanciaTotal).toFixed(2)+' Km.', fillColor: colores.footer, fontSize: 14 },
      { text: parseFloat(this.odometroTotal).toFixed(2)+' Km.', fillColor: colores.footer, fontSize: 14 },
    ]);
    const pdfData = { 
      titulo: 'DISTANCIA RECORRIDA',
      fecha: `Desde: ${this.filter.desde} - Hasta: ${this.filter.hasta}`,
      columnwidth: [ 'auto' , '*', 'auto', 'auto', 'auto' ],
      data: data
    };
    this.gtp.exportPdf(pdfData, 'distancia_recorrida');
    this.loadingPdf = false;
  }

  exportXls() {
    this.loadingXls = true;
    var fecha = `${this.filter.desde} - Hasta: ${this.filter.hasta}`;
    //Agregar Header
    var columns: any = [        
        'Cod Equipo',
        'Descripción',
        'Consumo',
        'Distancia',
        'Odometro Total',
    ];
    var rows: any = [];
    //Carga Registros
    this.dataSource.data.forEach((e,i) => {
      var consumo = (e.consumo != 0) ? e.consumo+' Litros' : 'Falta Personalizar';
      rows.push([        
        e.cod_equipo_rastreo,
        e.des_equipo_ratreo,
        consumo,
        parseFloat(e.distancia).toFixed(2)+' Km.',
        parseFloat(e.odo_inicial).toFixed(2)+' Km.',
      ]);
    });
    //Totales    
    rows.push([
        '',
        '',
        this.consumoTotal+' Litros.',
        parseFloat(this.distanciaTotal).toFixed(2)+' Km.',
        parseFloat(this.odometroTotal).toFixed(2)+' Km.',
    ]);
    this.gtp.exportExcel('DISTANCIA RECORRIDA', fecha, columns, rows, `distancia_recorrida`);
    this.loadingXls = false;
  }

}
